// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1mQ63","label":"Section_label__3Dw5Y","contentWrap":"Section_contentWrap__2phdR","footer":"Section_footer__1Sf1D","footerInner":"Section_footerInner__1Qp_G"};